import PropTypes from 'prop-types';
import React from 'react';
import ImageLoader from '../../../../shared/components/ImageLoader';
import './CampaignHeader.scss';

const CampaignHeader = ({
  campaignPic,
  isJoined
}) => (
  <div className={`banner ${isJoined ? 'isJoined' : ''}`}>
    <div className={isJoined ? "square" : ''}>
      <ImageLoader className='image' src={campaignPic} style={{ maxHeight: 200 }} />
    </div>
  </div >
);

CampaignHeader.propTypes = {
  campaignPic: PropTypes.string,
  isJoined: PropTypes.bool
};

CampaignHeader.defaultProps = {
  campaignPic: '',
  isJoined: false
};

export default React.memo(CampaignHeader);
